import(/* webpackMode: "eager" */ "/app/node_modules/@mui/material/CircularProgress/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/material/MenuItem/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/material/Switch/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/material/Tooltip/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["FormCalendar"] */ "/app/src/app/admin/student/holiday/ui/FormCalendar.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/form/InputDate.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DeleteFuntions"] */ "/app/src/components/funtions/DeleteFuntions.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/NetworkStatusBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ButtonDarkMode"] */ "/app/src/components/ui/buttons/ButtonDarkMode.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/ui/calendar/Event.css");
;
import(/* webpackMode: "eager" */ "/app/src/components/ui/left-menu/LeftMenu.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/ui/loading/LoadingPage.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/ui/modal/ModalComponent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AvatarUser"] */ "/app/src/components/ui/top-menu/ui/AvatarUser.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BtnHamburger"] */ "/app/src/components/ui/top-menu/ui/BtnHamburger.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FormGlobalFilter"] */ "/app/src/components/ui/top-menu/ui/FormGlobalFilter.tsx");
